module.exports = __webpack_public_path__ + "media/images/emblems/Bremgarten_bei_Bern-coat_of_arms-933ff4209a48167bb82ae93cfeb38a52.svg";